import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-speciale-view',
  templateUrl: './form-speciale-view.component.html',
  styleUrls: ['./form-speciale-view.component.css']
})
export class FormSpecialeViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
